import { createFileRoute, redirect } from '@tanstack/react-router';

// Deep-link redirect: stale /settings/analytics/$codebaseId/$tab bookmarks
// preserve the codebase and tab when forwarded to the new top-level route.
export const Route = createFileRoute('/$organizationName/settings/analytics/$codebaseId/$tab')({
  component: () => null,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$organizationName/analytics/$codebaseId/$tab',
      // The old path's `tab` is typed as a plain string; the new path narrows
      // it to a literal union. The actual values are identical between the two
      // routes (overview / branches / contributors), so a cast is safe here.
      params: params as { organizationName: string; codebaseId: string; tab: 'overview' | 'branches' | 'contributors' },
      search: search as any,
    });
  },
});
